import React from 'react';

import Button from './../styled/Button';
import Icon from './../styled/Icon';

const Dialogue = ({
  editor,
  onChange,
  closeMenu,
  type = 'heading-three',
  defaultBlock = 'paragraph',
}) => {
  if (!editor) return null;

  const { value } = editor;
  const isActive = value.blocks.some(node => node.type === type);

  return (
    <Button
      active={isActive}
      onMouseDown={(e) => {
        e.preventDefault();
        const change = value.change();
        if (isActive) {
          change.setBlocks(defaultBlock);
        } else {
          change.setBlocks(type);
        }
        onChange(change);
      }}
    >
      <Icon className='fas fa-heading' />
    </Button>
  );
};

export default Dialogue;
